<div class="container-center">
  <div class="logo-center">
    <div class="d-flex justify-content-center align-items-center flex-column">
      <div class="spinner-border text-light" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="loader-text mt-4">WB snapshot is being captured...</div>
    </div>
  </div>
</div>
